import { Box } from "@mui/material";
import { NonNullableDate } from "../../../../../../../../../utils/date-time-utility";
import Text from "../../../../../../../../../components/Text";
import {
  DEFAULT_BG_COLOR,
  DEFAULT_KEY_LABEL_COLOR,
  DEFAULT_LABEL_COLOR,
} from "../../../../../../../../../utils/utils";
import { SEVERITY_RECORD } from "../../../allergy/allergy-constant";

const AllergyRow: React.FC<{ label: string; value: React.ReactNode }> = ({
  label,
  value,
}) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "110px 8px 1fr",
      alignItems: "start",
    }}
  >
    <Text sx={{ color: DEFAULT_KEY_LABEL_COLOR }}>{label}</Text>
    <Text sx={{ color: DEFAULT_KEY_LABEL_COLOR }}>:</Text>
    <Text sx={{ color: "#222", wordBreak: "break-word" }}>{value}</Text>
  </Box>
);

interface AllergyData {
  uuid: string;
  allergyType: string | null;
  allergy: string;
  patient: Record<string, string>;
  reaction: string;
  severity: string;
  onSetDate: Date;
  note: string;
  active: boolean;
  archive: boolean;
  recordedDate: Date;
  modifiedDate: Date;
  appointmentId: string | null;
  providerStatus: string | null;
}

export const AllergiesTooltip: React.FC<{ data: AllergyData }> = ({ data }) => (
  <Box sx={{ minWidth: 250 }}>
    {/* Title Bar */}
    <Box
      sx={{
        background: DEFAULT_BG_COLOR,
        padding: "8px 12px",
      }}
    >
      <Text color={DEFAULT_LABEL_COLOR}>Allergy Details</Text>
    </Box>
    {/* Content */}
    <Box
      sx={{
        padding: "12px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <AllergyRow label="Allergy Name" value={data?.allergy} />
      <AllergyRow
        label="Severity"
        value={SEVERITY_RECORD[data?.severity] ?? data?.severity}
      />
      <AllergyRow label="Reaction" value={data?.reaction} />
      <AllergyRow label="Onset Date" value={NonNullableDate(data?.onSetDate)} />
      <AllergyRow label="Status" value={data?.active ? "Active" : "Inactive"} />
      <AllergyRow label="Note" value={data?.note} />
    </Box>
  </Box>
);
